import styled from 'styled-components';
import { BreakpointSizes } from 'dbi-pearl-ui-kit';

const WebstorePackagesStyled = styled.section`
    .packages-container {
        ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
            display: flex;
            flex-flow: row wrap;
            align-content: center;
            gap: 24px;
        }
    }
`;

export { WebstorePackagesStyled };
